import * as React from 'react';
import styled, { StyledComponent, DefaultTheme, CSSObject } from 'styled-components';
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/lib/Option';

export const containerStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'space-evenly',
    alignItems: 'center',
    display: 'flex',
}

export const Container = styled.div`
    ${containerStyle as CSSObject}
`;


export const ctxClass = (uri: string) => (name?: string) => name ? `${uri}_${name}` : uri;
export const splitClasses = (...classes: (string | undefined)[]) => classes.join(' ');


export const withConfig = 
    <S, H extends HTMLElement>() => 
        <T, P>(cfg: T) => 
            (Component: StyledComponent<any, DefaultTheme, { cfg: T }>) => 
                React.forwardRef<H, P & S & React.HTMLAttributes<H>>((props, ref) => {
                    return (
                        <Component 
                            cfg={cfg} 
                            ref={ref}
                            {...props}
                        />
                    );
                });


export const observeEffect = (targetRef: React.RefObject<HTMLElement>, intersectParent: IntersectionObserver) =>
    pipe(
        targetRef,
        (x) => x.current,
        O.fromNullable,
        O.fold(
            () => () => () => {},
            (x) => () => {
                intersectParent.observe(x);

                return () => intersectParent.unobserve(x);
            }
        )
    );
